/**
 * @fileoverview Componente responsável por isolar falhas de renderização e evitar que a interface inteira quebre.
 */

import React from "react";
import { toast } from "react-toastify";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] UI crash capturado:", error, info);
    toast.error("Ocorreu um erro na interface. Atualize a página ou tente novamente.");
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            gap: 12,
            padding: 24,
            textAlign: "center",
            fontFamily: "'Inter', sans-serif"
          }}
        >
          <div style={{ fontSize: 16, fontWeight: 600, color: "#64748b" }}>
            Ocorreu um erro na interface
          </div>
          <div style={{ fontSize: 13, color: "#94a3b8" }}>
            Recarregue a página para continuar o atendimento.
          </div>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: 8,
              padding: "8px 18px",
              borderRadius: 8,
              border: "none",
              background: "#3B5CFF",
              color: "#fff",
              fontWeight: 600,
              cursor: "pointer"
            }}
          >
            Recarregar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
